import { render, staticRenderFns } from "./left-aside.vue?vue&type=template&id=d2bcacfc&"
import script from "./left-aside.vue?vue&type=script&lang=js&"
export * from "./left-aside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports